<template>
  <div class="p-grid">
    <div class="p-col-12 p-lg-4 p-md-6">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="pi pi-file"></i></span>
        <InputText
          placeholder="ระบุ Document Id..."
          maxlength="13"
          v-model="documentId"
        ></InputText>
        <Button icon="pi pi-send" @click="onGoToDocument"></Button>
      </div>
    </div>
    <div class="p-col-12">
      <Card>
        <template #title="">ข้อมูลหลัก</template>
        <template #content="">
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="competency">Competency</router-link>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="skill">ประเภททักษะ</router-link>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="courseType">ประเภทหลักสูตร</router-link>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="course">หลักสูตร</router-link>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="questions">แบบประเมิน</router-link>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link :to="{ name: 'courseRelationList' }"
                >ความสัมพันธ์ของตำแหน่งและหลักสูตรการฝึกอบรม
              </router-link>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="employees">ข้อมูลพื้นฐานบุคคล</router-link>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="instructor">ประวัติวิทยากร</router-link>
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div class="p-col-12">
      <Card>
        <template #title="">ทำรายการ</template>
        <template #content="">
          <div class="p-grid">
            <!-- <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="underConstruction">เอกสาร Competency</router-link
              ><i class="pi pi-eye-slash p-ml-2"></i>
            </div> -->
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="trainingDocumentList"
                >เอกสารการฝึกอบรม
              </router-link>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="positionList"
                >เอกสารพนักงานใหม่/ย้ายแผนก/เลื่อนตำแหน่ง
              </router-link>
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link :to="{ name: 'onTheJobList' }"
                >เอกสารอบรมต้นสังกัด
              </router-link>
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div class="p-col-12">
      <Card>
        <template #title="">รายงาน</template>
        <template #content="">
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="trainingReport">
                รายละเอียดการฝึกอบรม
              </router-link>
            </div>
            <!-- <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="underConstruction"
                >รายชื่อผู้เข้าอบรม</router-link
              ><i class="pi pi-eye-slash p-ml-2"></i>
            </div> -->
            <!-- <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="underConstruction"
                >Competency Assessment</router-link
              ><i class="pi pi-eye-slash p-ml-2"></i>
            </div> -->
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="agingReport"
                >รายงานอายุเอกสาร (Aging Report)</router-link
              >
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link to="notificationLogs"
                >ประวัติการแจ้งเตือน</router-link
              >
            </div>
          </div>
        </template>
      </Card>
    </div>
    <div class="p-col-12">
      <Card>
        <template #title="">อื่น ๆ</template>
        <template #content="">
          <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link :to="{ name: 'configUser' }"
                >สิทธิการใช้งานระบบ</router-link
              >
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link :to="{ name: 'configPdpa' }"
                >กำหนดข้อความ PDPA</router-link
              >
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link :to="{ name: 'configQuestionSet' }"
                >ตั้งค่าชุดแบบประเมิน และการติดตามผล</router-link
              >
            </div>
            <div class="p-col-12 p-lg-3 p-md-4">
              <router-link :to="{ name: 'configParameter' }"
                >ตั้งค่าอื่น ๆ</router-link
              >
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { usePlugin } from "@/plugins";

export default defineComponent({
  name: "GrandMenu",
  setup() {
    const { router } = usePlugin();
    const documentId = ref("");
    const onGoToDocument = () => {
      router.push({
        name: "editTrainingDocument",
        params: { docNo: documentId.value },
      });
    };

    return {
      onGoToDocument,
      documentId,
    };
  },
});
</script>

<style></style>
